// React 19 uyumluluğu: antd v5 statik metodları (message, notification,
// Modal.confirm/info/...) React 19'da bu patch olmadan çalışmaz. antd
// yüklenmeden önce, en üstte import edilmeli.
import "@ant-design/v5-patch-for-react-19";

import { initSentry, Sentry } from "./lib/sentry";

initSentry();

// Yeni sürüm yüklenince eski parça dosyaları sunucudan silinir; açık kalmış
// bir sekme sayfa değiştirirken bu dosyaları ister ve hata alır. Vite bunu
// "vite:preloadError" olarak bildirir → sayfayı bir kez yenile (yeni sürüm
// gelir). Döngüye girmemek için 30 sn içinde ikinci kez yenilenmez.
window.addEventListener("vite:preloadError", (event) => {
  const KEY = "edel_chunk_reload_at";
  let last = 0;
  try {
    last = Number(window.sessionStorage.getItem(KEY) || 0);
  } catch {
    /* gizli sekme vb. — yoksay */
  }
  if (Date.now() - last < 30_000) return;
  try {
    window.sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    /* yoksay */
  }
  event.preventDefault();
  window.location.reload();
});

import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div style={{ padding: 24, fontFamily: "system-ui, sans-serif" }}>
          <p>Bir hata oluştu.</p>
          <button type="button" onClick={() => window.location.reload()}>
            Sayfayı yenile
          </button>
        </div>
      }
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
